const reportRouter = [
    {
        path: "list-report",
        name: "report",
        component: () => import("@/views/admin/report"),
        default: true,
        meta: {
            model: "report",
            // requiresAuth: true,
        },
    },
    // {
    //     path: "list-report/add",
    //     name: "addReport",
    //     component: () => import("@/views/admin/report/function"),
    //     default: true,
    //     meta: {
    //         model: "report",
    //         // requiresAuth: true,
    //     },
    // },
    {
        path: "list-report/edit/:id",
        name: "editReport",
        component: () => import("@/views/admin/report/function"),
        default: true,
        meta: {
            model: "report",
            // requiresAuth: true,
        },
    },
];
export default reportRouter;